import { useEffect } from 'react';

const Qualtrics = () => {
  useEffect(() => {
    setTimeout(() => {
      const getQSI = () => typeof window !== 'undefined' && window.QSI;

      const isQSILoaded = qsi => {
        const api = qsi?.API;
        const requiredMethods = ['load', 'unload', 'run'];
        return !!api && requiredMethods.every(method => !!api[method]);
      };

      const loadQualtrics = qsi => {
        const api = qsi?.API;
        api.unload();
        api.load();
        api.run();
      };

      const tryToLoadQualtrics = () => {
        // eslint-disable-next-line no-console -- hack to by pass webpack stripping console.warn
        const warn = console.warn.bind(console);

        const qsi = getQSI();

        if (!isQSILoaded(qsi)) {
          warn('Qualtrics API not found');
          return;
        }

        try {
          loadQualtrics(qsi);
        } catch (error) {
          warn('Qualtrics API Failed to run', error);
        }
      };

      tryToLoadQualtrics();
    }, 5000);
  }, []);
  return null;
};

export default Qualtrics;
